import { Link, styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const Imprint: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <Typography variant="h4" color="primary" textAlign="center" gutterBottom>
                {t("imprint")}
            </Typography>
            <Typography>{t("imprint_teaser")}</Typography>
            <Typography variant="h5" gutterBottom style={{ marginTop: 20 }}>
                {t("imprint_responsible_for_content")}
            </Typography>
            <Typography>{t("imprint_responsible_for_content_name")}</Typography>
            <Link color="primary" href="mailto: office@dhp.lbg.ac.at">
                office@dhp.lbg.ac.at
            </Link>
            <Typography variant="h5" gutterBottom style={{ marginTop: 20 }}>
                {t("used_material")}
            </Typography>
            <Typography>
                {t("illustration")}
                <Link color="primary" href="https://storyset.com/" target="_blank">
                    Storyset by Freepik
                </Link>
            </Typography>
        </Container>
    );
};

export default Imprint;

export const Container = styled("div")`
    padding: 30px;
`;
